// checks if value is a valid ObjectID -> https://github.com/Automattic/mongoose/issues/1959
export const isValidPatientIdFormat = (value: string) => value.match(/^[0-9a-fA-F]{24}$/);
